<template>
  <div style="background-color: white; min-height: 100vh">
    <Header></Header>
    <!-- <div style="position: relative; color: white; font-family: 'mediumRoboto'">
      <img src="../assets/images/app-snow-hero.jpeg" class="eventImg" />
      <div class="bottom-left">
        <h1 class="eventLarge whiteText">Parkspass App</h1>
      </div>
    </div> -->
    <main id="main-content" tabindex="-1">
      <div>
        <div class="hero-image">
          <div class="activate-pass-wrap">
            <div class="activate-pass">
              <div class="logo-text">
                <img
                  src="../assets/images/dnr-app.svg"
                  alt="dnr logo"
                  class="dnr-logo"
                />
                <div class="text-wrap">
                  <!-- <h3 class="activate">Register Your Pass</h3> -->
                  <h2 class="download">Keep your Annual Pass on your phone</h2>
                  <!-- <h4 class="digital">
                  Haven’t Purchased a Pass?
                  <a
                    class="buy-pass-now"
                    href="https://parkspass.utah.gov/parks/PANUAL/dayuse"
                    >Buy a Pass Now!</a
                  >
                </h4> -->
                  <button class="button" @click="Device()">
                    Get the app
                    <img
                      style="padding-left: 10px"
                      src="../assets/images/phone-icon.svg"
                      alt="phone icon"
                    />
                  </button>
                  <h4 class="blur-text">
                    Keep your annual pass on your phone with the Utah State
                    Parks app. The app uses a QR code for easy entrance into
                    Utah’s State Parks. Never stress about losing your pass.
                    Keep it on your phone.
                  </h4>
                </div>
              </div>

              <!-- <div class="store-buttons">
              <img
                @click="goToAndroid"
                class="store-icon android"
                src="../assets/images/app_store/android.svg"
              />
              <img
                @click="goToIOS"
                class="store-icon iphone"
                src="../assets/images/app_store/ios.svg"
              />
            </div> -->
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="topo-lines">
          <!-- <img src="../assets/images/annual-pass-phones.png" class="" /> -->
          <div class="topo-content">
            <h1 class="topo-text">
              Annual Pass<br />
              Storage &<br />
              Renewal
            </h1>
            <h4 class="topo-reg">
              The Parkspass App offers a place to store your annual pass with a
              link to renew your pass each year.
            </h4>
            <h4 class="topo-bold">Download free for iOS or Android</h4>
            <button class="button" @click="Device()">
              Get the app
              <img
                style="padding-left: 10px"
                src="../assets/images/phone-icon.svg"
                alt="phone icon"
              />
            </button>
          </div>
          <div class="phone-wrap">
            <img src="../assets/images/app-phone.svg" />
          </div>
        </div>
      </div>
      <div class="page-wrap">
        <!-- <v-breadcrumbs
        divider="/"
        :items="breadcrumbs"
        class="breadcrumbs"
      ></v-breadcrumbs> -->

        <div class="three">
          <div class="item center">
            <img id="qr-person" src="../assets/images/other-app-phone.svg" />
          </div>
          <div class="item">
            <div class="details">
              <h2 class="highlights-features">
                Digital <br />
                Brochures
              </h2>
              <p class="words-broch">
                Now, you can access digital brochures for every park through the
                app.
              </p>
              <h4 class="broch-text">Get information like...</h4>
              <div class="information-box">
                <img
                  style="padding: 0 30px 0 20px"
                  src="../assets/images/checkmark.svg"
                  alt="park history"
                />park history
              </div>
              <div class="information-box">
                <img
                  style="padding: 0 30px 0 20px"
                  src="../assets/images/checkmark.svg"
                  alt="park history"
                />campground maps
              </div>
              <div class="information-box">
                <img
                  style="padding: 0 30px 0 20px"
                  src="../assets/images/checkmark.svg"
                  alt="park history"
                />park hours
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="feat" class="footer">
        <h3>Follow Parkspass on Social Media</h3>
        <div class="app-icon">
          <a
            v-if="!isMobile()"
            href="https://instagram.com/parkspass?igshid=NWRhNmQxMjQ="
          >
            <img
              class="app-icons"
              src="../assets/images/new-Instagram-logo.svg"
            />
          </a>
          <a v-else href="instagram://user?username=parkspass">
            <img class="app-icons" src="../assets/images/app_store/insta.svg" />
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=100068962068011"
            target="_blank"
          >
            <img
              style="margin-top: 20px"
              class="app-icons"
              src="../assets/images/facebook-white.svg"
            />
          </a>
          <a href="https://www.linkedin.com/company/parkspass/" target="_blank">
            <img
              style="margin-top: 20px"
              class="app-icons"
              src="../assets/images/linkedin-icon.svg"
              alt="linkedin logo"
            />
          </a>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import $ from "jquery";
export default {
  name: "AppStore",
  metaInfo: {
    title: "App store annual pass",
    meta: [
      {
        name: "description",
        content: "Purchase your Digital Annual Pass.",
      },
    ],
  },
  components: {
    Header,
  },
  data() {
    return {
      breadcrumbs: [],
      phone: "",
    };
  },
  created() {
    this.breadcrumbs = [
      { text: "Home", disabled: false, href: "/" },
      { text: "App", disabled: true },
    ];
  },
  mounted() {
    this.loadShopifyCollection();
    const header = document.getElementById("header");
    if (header) {
      header.scrollIntoView();
    }
  },
  methods: {
    Device() {
      const ua = navigator.userAgent || navigator.vendor || window.opera;
      const platform = navigator.platform.toLowerCase();

      // --- MOBILE DETECTION ---
      const isIOSMobile =
        (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1); // iPadOS

      const isAndroidMobile = /android/i.test(ua);

      // --- DESKTOP DETECTION ---
      const isMacDesktop = platform.includes("mac");
      const isWindowsDesktop = platform.includes("win");
      const isLinuxDesktop = platform.includes("linux");

      // --- ROUTING LOGIC ---
      if (isIOSMobile || isMacDesktop) {
        this.goToIOS();
      } else if (isAndroidMobile || isWindowsDesktop || isLinuxDesktop) {
        this.goToAndroid();
      } else {
        console.log("Unknown device — defaulting to Google Play");
        this.goToAndroid();
      }
    },
    loadShopifyCollection: function () {
      if (window.Evey) {
        if (window.Evey.buy_button) {
          $(document).ready(() => {
            this.EveyShopifyBuyInit();
          });
        } else {
          this.loadScript();
        }
      } else {
        this.loadScript();
      }
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        console.log("is mobile");
        return true;
      } else {
        console.log("desktop");
        return false;
      }
    },
    goToAndroid() {
      // this.phone = "Android";
      // localStorage.setItem("phone", this.phone);
      // this.$router.push("/app/android");
      window.location.href =
        "http://play.google.com/store/apps/details?id=edu.utahtech.parkspass.utahstateparks";
    },
    goToIOS() {
      // this.phone = "IOS";
      // localStorage.setItem("phone", this.phone);
      // this.$router.push("/app/ios");
      window.location.href =
        "https://apps.apple.com/us/app/utah-state-parks/id1638662132";
    },
  },
};
</script>

<style scoped>
.hero-image {
  background-image: url("../assets/images/app-hero.png");
  width: 100%;
  height: 90%;
  flex-shrink: 0;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  color: white;
  font-family: "mediumRoboto";
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.broch-text {
  color: rgba(0, 0, 0, 0.86);
  font-family: Roboto;
  font-size: 30px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px; /* 106.667% */
  letter-spacing: 0.15px;
  padding-bottom: 25px;
}

.text-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.activate-pass-wrap {
  display: flex;
  justify-content: center;
}
.text-topo {
  color: #0a0b0a;
  font-size: 18px;
}

.topo-content {
  padding-right: 100px;
}

.words-broch {
  color: rgba(0, 0, 0, 0.86);
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px; /* 133.333% */
  letter-spacing: 0.12px;
  padding-bottom: 40px;
}

.activate-pass {
  background: rgba(0, 0, 0, 0.2);
  /* height: 250px; */
  width: 63%;
  height: 95%;
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  /* align-items: center; */
  color: white;
  padding: 30px;
  border-radius: 18px;
  margin: 130px 0 130px 0;
  backdrop-filter: blur(26px);
}
.information-box {
  background: #eeeae5;
  width: 400px;
  height: 70px;
  color: #0a0b0a;
  font-family: Roboto;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 25px;
}

.blur-text {
  color: #fff;
  text-align: center;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
  padding: 0 100px 40px 100px;
}

.topo-bold {
  color: rgba(0, 0, 0, 0.86);
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.12px;
  padding-bottom: 40px;
}

.topo-reg {
  color: rgba(0, 0, 0, 0.86);
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px; /* 133.333% */
  letter-spacing: 0.12px;
  width: 413px;
  padding-bottom: 40px;
}

.logo-text {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.button {
  width: 177px;
  height: 56px;
  flex-shrink: 0;
  border-radius: 5px;
  background: #727a35;
  color: #ffffff;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 40px;
}

.dnr-logo {
  margin-right: 1em;
  padding: 30px 0 30px 0;
}
.topo-text {
  color: #0a0b0a;
  font-size: 64px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
  letter-spacing: 0.32px;
  padding-bottom: 40px;
}
.topo-lines {
  background-image: url("../assets/images/topo-map.svg");
  width: 100%;
  height: 881px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.phone-wrap {
  display: flex;
  overflow: auto;
  white-space: nowrap;
}

.choose-mockup {
  margin: 0px 70px 0px 70px;
}

.white-text {
  color: white;
}

.digital {
  color: #fff;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 36px; /* 150% */
  letter-spacing: 0.12px;
}

.buy-pass-now {
  color: #96a145;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 36px;
  letter-spacing: 0.12px;
}

.download {
  color: #fff;
  text-align: center;
  font-family: Roboto;
  font-size: 64px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
  letter-spacing: 0.32px;
  padding-bottom: 40px;
}

.activate {
  color: #fff;
  font-family: Roboto;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 36px; /* 112.5% */
  letter-spacing: 0.16px;
}
.v-breadcrumbs__item--disabled {
  color: rgba(0, 0, 0, 0.38);
}
p {
  font-size: 20px;
  color: #2e2e31;
}
#description {
  margin-top: 40px;
  line-height: 36px;
}
h1 {
  font-size: 96px;
  color: #ffffff;
}
h2 {
  color: #2e2e31db;
  font-size: 48px;
  line-height: 56px;
  font-family: "boldRoboto";
}
h3 {
  color: #2e2e31db;
  font-size: 32px;
  font-family: "Roboto";
  margin-bottom: 5px;
}
.divider {
  margin: 24px 0px;
}
.page-wrap {
  padding: 32px;
  max-width: 1600px;
  margin: 0 auto;
}
.eventImg {
  width: 100%;
  max-height: 350px;
  object-fit: cover;
  object-position: center;
  height: auto;
  position: relative;
}
.bottom-left {
  position: absolute;
  bottom: 0px;
  width: 100%;
  max-width: 1600px;
  padding: 32px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
}
b {
  font-weight: bold;
}
.v-breadcrumbs ::v-deep(a) {
  color: #96a145;
}
.passText {
  display: inline-block;
  font-size: 16px;
  line-height: 24px;
  margin: 0px;
}
a {
  text-decoration: none;
  color: #96a145;
}
.v-breadcrumbs {
  padding: 18px 0px;
}
.three {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  text-align: center;
  margin-top: 50px;
  justify-content: center;
}
.item {
  flex: 0 0;
  text-align: left;
}
.item.center {
  flex: 0 0 40%;
  padding-right: 15px;
}
.store-icon {
  max-height: 48px;
  margin-right: 8px;
}

.android:hover {
  cursor: pointer;
}
.iphone:hover {
  cursor: pointer;
}
#store-icons {
  margin-top: 60px;
}

.store-buttons {
  /* margin-top: 60px; */
  display: flex;
}

.shrink {
  max-width: 45%;
  width: 300px;
  margin-right: 25px;
}
#feat {
  text-align: center;
  margin-top: 75px;
  /* margin-bottom: 100px; */
  padding: 50px 0px 50px 0px;
  background: rgba(150, 161, 69, 0.05);
}

.highlights-features {
  color: #0a0b0a;
  font-size: 64px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
  letter-spacing: 0.32px;
  margin-bottom: 30px;
}
#qr-person {
  max-width: 90%;
  margin-top: 35px;
}
#qr-person-mobile {
  max-width: 320px;
  display: none;
  margin: auto;
}
.low {
  margin-top: 100px;
}
.app-icon {
  margin-top: 30px;
}
.app-icons {
  margin-right: 12px;
}
/* #iphones {
  width: 40%;
} */
@media only screen and (max-width: 1440px) {
  .shrink {
    max-width: 40%;
    /* width: 300px; */
    margin-right: 25px;
  }
  #iphones {
    width: 40%;
  }
}
@media only screen and (max-width: 1440px) {
  #iphones {
    width: 40%;
  }
  .download {
    font-size: 56px;
  }
}

@media only screen and (max-width: 1025px) {
  .activate {
    font-size: 24px;
  }
  .topo-content {
    padding-right: 62px;
    padding-left: 33px;
  }
  .download {
    font-size: 56px;
  }
  .blur-text {
    padding: 0 40px 30px 40px;
  }

  .digital {
    font-size: 18px;
  }
}

@media only screen and (max-width: 950px) {
  #store-icons {
    display: flex;
  }
  .download {
    font-size: 56px;
  }
  .activate-pass {
    flex-direction: column;
    justify-content: flex-start;
    border-radius: 25px;
    margin-bottom: 0px;
    padding: 20px;
    margin: 30px 0 30px 0;
  }

  .activate-pass-wrap {
    width: 100%;
  }
}
@media only screen and (max-width: 860px) {
  .bottom-left {
    padding: 25px;
  }
  .topo-content {
    padding-right: 0px;
    align-content: center;
  }
  .words-broch {
    width: 400px;
  }
  .topo-text {
    padding-bottom: 20px;
  }
  .highlights-features {
    color: #0a0b0a;
    font-size: 64px;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
    letter-spacing: 0.32px;
    margin-bottom: 30px;
    padding-right: 113px;
  }

  .dnr-logo {
    height: 40%;
    width: 40%;
  }

  .download {
    color: #fff;
    font-family: Roboto;
    font-size: 50px;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
    letter-spacing: 0.1px;
  }

  .topo-lines {
    display: flex;
    flex-direction: column-reverse;
  }

  .blur-text {
    color: #fff;
    text-align: center;
    font-family: Roboto;
    font-size: 21px;
    font-style: normal;
    font-weight: 400;
    padding: 0px;
  }

  .digital {
    color: #fff;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 36px; /* 257.143% */
    letter-spacing: 0.07px;
  }

  .buy-pass-now {
    color: #96a145;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 36px;
    letter-spacing: 0.07px;
  }
  #qr-person {
    padding-left: 130px;
  }

  .activate {
    color: #fff;
    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 36px; /* 200% */
    letter-spacing: 0.09px;
  }
  .page-wrap {
    padding: 16px;
  }
  .eventImg {
    /* filter: brightness(80%); */
    object-position: top;
    height: 350px;
  }
  h1 {
    font-size: 48px;
  }
  h2 {
    font-size: 36px;
    line-height: 42px;
  }
  p {
    font-size: 16px;
    line-height: 26px;
    font-family: "Roboto";
  }
  .three {
    display: inline;
  }
  .shrink {
    display: flex;
    margin: auto;
    max-width: 95%;
  }
  .item.center {
    padding-right: 0px;
  }
  #store-icons {
    margin-top: 24px;
    margin-bottom: 50px;
  }

  .app-icon {
    display: inline-grid;
    display: flex;
    align-items: flex-end;
    justify-content: center;
  }
  .store-icon {
    width: 130px;
    /* display: flex; */
    margin: auto;
  }
  #description[data-v-8f6132d2] {
    margin-top: 24px;
    line-height: 26px;
  }
  #feat {
    font-size: 36px;
    line-height: 42px;
    text-align: center;
  }

  #qr-person-mobile {
    display: flex;
  }
  .low {
    margin-top: 0;
  }
  .details {
    margin-top: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  #iphones {
    width: 95%;
  }
}
@media only screen and (max-width: 665px) {
  .activate-pass {
    width: 80%;
    margin: 30px 0 30px 0;
  }
  .topo-content {
    padding: 0 50px 0 50px;
    align-content: center;
  }
  .download {
    font-size: 40px;
  }
}
@media only screen and (max-width: 425px) {
  .hero-image {
    height: 100%;
  }
  .topo-content {
    padding: 0 20px 0 50px;
  }
  .highlights-features {
    color: #0a0b0a;
    font-size: 64px;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
    letter-spacing: 0.32px;
    margin-bottom: 30px;
    padding-right: 88px;
  }
  .words-broch {
    width: 375px;
  }
  .download {
    font-size: 40px;
  }
  .information-box {
    width: 95%;
  }
  .blur-text {
    color: #fff;
    text-align: center;
    font-family: Roboto;
    font-size: 21px;
    padding: 0px;
  }
  .topo-lines {
    display: flex;
    flex-direction: column-reverse;
  }
  .activate-pass {
    width: 80%;
    margin: 40px 0 40px 0;
  }

  .dnr-logo {
    height: 40%;
    width: 40%;
  }
  .h3 {
    font-size: 27px;
  }
  .app-icon {
    display: flex;
    align-items: flex-end;
    justify-content: center;
  }
}
@media only screen and (max-width: 425px) {
  .topo-content {
    padding: 0px 0px 0 0px;
    width: 295px;
  }
  .topo-text {
    padding-bottom: 20px;
    font-size: 50px;
  }
  .topo-reg {
    font-size: 20px;
    width: 308px;
  }
  .highlights-features {
    font-size: 50px;
    padding-right: 50px;
  }
  .words-broch {
    font-size: 20px;
    width: 308px;
    padding-left: 15px;
  }
  #qr-person {
    padding-left: 40px;
  }
}
</style>
